import React, { useState } from "react";
import { Paper, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import CustomTabs, { TabPanel } from "./CustomTabs";
import { categoriesData } from "./categoriesData";
import { useTheme } from "@emotion/react";
import Hint from "../Crosspage/Hint";
import { Swipe } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function Home(props) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
  };

  const swipeHint = (
    <Box sx={{ pt: 5, width: "fit-content", m: 1 }}>
      <Swipe color="primary" />
      <Typography>{t("swipeHint")}</Typography>
    </Box>
  );

  const content = categoriesData(t)[Object.keys(categoriesData(t))[tabValue]];

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          maxWidth: 800,
          margin: "auto",
          padding: { xs: 0, sm: 2, md: 3 },
        }}
      >
        <Paper
          variant="outlined"
          elevation={0}
          sx={{
            pt: 3,
            pb: 3,
            p: 1,
            backgroundColor: "#eee",
          }}
        >
          <Box sx={{ display: "inline" }}>
            <Typography
              variant="h1"
              sx={{
                mt: 1,
                color: "primary.main",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Gekonnt hanDeln -
            </Typography>
            <Typography
              variant="h6"
              sx={{
                // my: 2,
                // fontStyle: "italic",
                fontSize: "1.25rem",
                color: "text.secondary",
                textAlign: "center",
              }}
            >
              "Gesund und kompetent in haushaltsnahen Dienstleistungen"
            </Typography>
          </Box>
          <Paper
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "primary.lightest",
              my: 1,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "medium",
                color: "secondary.contrastText",
                textAlign: "center",
              }}
            >
              Die Plattform für privat angestellte Haushaltshilfen
            </Typography>
          </Paper>
          <>
            <CustomTabs
              names={Object.keys(categoriesData(t))}
              handleTabChange={handleTabChange}
              tabValue={tabValue}
            />
            {!props.seenSwipeHint && isXs && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Hint
                  handleHintClosed={props.setSwipeHintSeen}
                  hint={swipeHint}
                  fitContent
                />
              </Box>
            )}
            <TabPanel value={tabValue} dir={theme.direction}>
              {content}
            </TabPanel>
          </>
        </Paper>
      </Box>
    </Box>
  );
}
